var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMazdaLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 63,
    viewBox: "0 0 69 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_402_5155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.357 63.0001C59.7931 63.0001 58.9473 62.8911 58.7221 62.8367C57.2191 62.4493 56.5558 61.0329 56.5619 59.8041C56.5679 58.6661 57.1582 57.1952 58.7951 56.7957C59.3002 56.6686 59.9939 56.6141 60.9736 56.6141H65.5619V56.0512C65.5619 55.234 65.0385 55.0827 64.0041 55.0827H57.3286V52.601H64.783C66.3103 52.601 67.4239 52.7584 68.2393 53.5574C69.0122 54.3079 69 55.1735 69 56.481V63.0001H61.357ZM61.4057 58.6298C60.9615 58.6298 60.4199 58.6661 60.1278 58.9627C59.9635 59.1322 59.8783 59.3562 59.8783 59.6467C59.8783 59.9373 59.9635 60.1552 60.1278 60.3307C60.4199 60.6273 60.9615 60.6636 61.4057 60.6636H65.5862V58.6237H61.4057V58.6298ZM34.0771 63.0001L37.6065 60.4397H42.1704V63.0001H34.0771ZM22.3509 63.0001C20.9574 63.0001 20.1055 62.9093 19.8073 62.8367C18.3043 62.4493 17.6349 61.0329 17.6471 59.8041C17.6531 58.6661 18.2434 57.1952 19.8864 56.7957C20.4158 56.6686 21.0183 56.6141 21.9736 56.6141H26.6471V56.0512C26.6471 55.234 26.1237 55.0827 25.0892 55.0827H18.5781V52.601H25.783C27.3103 52.601 28.4178 52.7584 29.2393 53.5574C30.0122 54.3079 30 55.1735 30 56.487V60.9663L41.428 52.607H50.355C52.1684 52.607 52.9959 52.6918 53.8965 52.9823C54.8945 53.3334 55.43 53.7753 55.8621 54.6106C56.3306 55.5125 56.3854 56.8684 56.3854 57.8126C56.3854 58.7569 56.3306 60.1128 55.8621 61.0147C55.43 61.85 54.8945 62.2858 53.9087 62.6369C52.9959 62.9275 52.1684 63.0122 50.355 63.0122H43.5456V54.659L32.0203 63.0122H22.357L22.3509 63.0001ZM22.3996 58.6298C21.8824 58.6298 21.4807 58.6903 21.2069 58.9627C21.0426 59.1322 20.9574 59.3562 20.9574 59.6467C20.9574 59.9373 21.0365 60.1552 21.2069 60.3307C21.4807 60.6091 21.8763 60.6636 22.3935 60.6636H26.6653V58.6237H22.3935L22.3996 58.6298ZM50.1055 60.4397C51.5172 60.4397 51.8884 60.3368 52.217 60.0886C52.7647 59.683 52.9412 59.1261 52.9412 57.8005C52.9412 56.4749 52.7647 55.918 52.217 55.5125C51.8824 55.2643 51.5172 55.1614 50.1055 55.1614H47.0264V60.4397H50.1055ZM13.8682 63.0001V56.7534C13.8682 56.2207 13.7647 55.8938 13.5213 55.6396C13.2475 55.3551 12.8763 55.234 12.2799 55.234H10.3692V62.994H6.9858V55.234H3.48073V62.994H0V52.5889H13.0345C16.1927 52.5889 17.3671 53.4787 17.3671 55.8636V62.988H13.8621L13.8682 63.0001ZM31.0892 55.1554V52.5949H39.4686L35.9696 55.1554H31.0892Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.357 62.4857C59.7931 62.4857 59.002 62.3768 58.8499 62.3344C57.6146 62.0196 57.073 60.8332 57.0791 59.8042C57.0852 58.8478 57.572 57.6191 58.9229 57.2922C59.3915 57.1772 60.0426 57.1227 60.9736 57.1227H66.0791V56.0453C66.0791 54.5623 64.6795 54.5623 64.0041 54.5623H57.8458V53.1096H64.783C66.1826 53.1096 67.1866 53.2427 67.8803 53.9207C68.4645 54.4957 68.4828 55.1192 68.4828 56.4751V62.4857H61.357ZM61.4057 58.1154C60.8641 58.1154 60.1826 58.1699 59.7566 58.6057C59.4949 58.8781 59.3611 59.2231 59.3611 59.6468C59.3611 60.0706 59.4888 60.4216 59.7566 60.688C60.1826 61.1238 60.858 61.1783 61.4057 61.1783H66.1034V58.1154H61.4057ZM35.6653 62.4857L37.7769 60.9543H41.6531V62.4857H35.6653ZM22.3509 62.4857C20.9087 62.4857 20.1359 62.3889 19.929 62.3344C18.6998 62.0196 18.1521 60.8332 18.1582 59.8042C18.1643 58.8478 18.6511 57.6191 20.002 57.2922C20.4888 57.1712 21.0548 57.1227 21.9675 57.1227H27.1582V56.0453C27.1582 54.5623 25.7586 54.5623 25.0832 54.5623H19.0892V53.1096H25.7769C27.1704 53.1096 28.1805 53.2427 28.8682 53.9207C29.4584 54.4957 29.4706 55.1192 29.4706 56.4751V61.9773L41.5862 53.1096H50.3428C52.0953 53.1096 52.8864 53.1883 53.7262 53.4606C54.5903 53.7693 55.0162 54.1144 55.3935 54.8347C55.8134 55.6337 55.8621 56.9109 55.8621 57.8007C55.8621 58.6905 55.8134 59.9677 55.3935 60.7667C55.0162 61.487 54.5963 61.832 53.7262 62.1407C52.8925 62.407 52.0953 62.4918 50.3428 62.4918H44.0507V53.6362L31.8438 62.4918H22.3448L22.3509 62.4857ZM22.3996 58.1154C21.8398 58.1154 21.2617 58.176 20.8357 58.6057C20.574 58.8781 20.4402 59.2231 20.4402 59.6468C20.4402 60.0706 20.574 60.4216 20.8357 60.688C21.2617 61.1177 21.8337 61.1783 22.3996 61.1783H27.1826V58.1154H22.3996ZM46.5091 60.9543H50.1055C51.5294 60.9543 52.0527 60.8575 52.5274 60.5003C53.3124 59.9192 53.4584 59.1021 53.4584 57.8007C53.4584 56.4993 53.3124 55.6821 52.5274 55.101C52.0467 54.7439 51.5294 54.647 50.1055 54.647H46.5091V60.9604V60.9543ZM14.3854 62.4857V56.7535C14.3854 56.0877 14.2333 55.6337 13.8986 55.2826C13.5213 54.8952 13.0223 54.7197 12.286 54.7197H9.85801V62.4797H7.50913V54.7197H2.96957V62.4797H0.517241V53.1035H13.0345C16.2596 53.1035 16.8499 54.0357 16.8499 55.8637V62.4736H14.3793L14.3854 62.4857ZM31.6065 54.641V53.1096H37.8864L35.7931 54.641H31.6065Z",
    fill: "url(#paint0_linear_402_5155)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6653 62.4855H41.6531V60.9541H37.7769L35.6653 62.4855ZM41.5254 61.0812V62.3584H36.0548L37.8195 61.0812H41.5254ZM67.8803 53.9205C67.1866 53.2486 66.1826 53.1094 64.783 53.1094H57.8458V54.5621H64.0041C64.6795 54.5621 66.0791 54.5621 66.0791 56.0451V57.1225H60.9736C60.0365 57.1225 59.3854 57.177 58.9229 57.292C57.572 57.6189 57.0852 58.8537 57.0791 59.804C57.073 60.8391 57.6146 62.0194 58.8499 62.3342C59.002 62.3705 59.7931 62.4855 61.357 62.4855H68.4828V56.4749C68.4828 55.119 68.4706 54.4895 67.8803 53.9205ZM68.355 56.4749V62.3584H61.357C59.8053 62.3584 59.0325 62.2495 58.8803 62.2131C57.7181 61.9165 57.2008 60.7846 57.2069 59.804C57.2069 58.8961 57.6755 57.7218 58.9533 57.4131C59.4097 57.2981 60.0487 57.2497 60.9736 57.2497H66.2069V56.0451C66.2069 54.435 64.6613 54.435 64.0041 54.435H57.9736V53.2365H64.783C66.1521 53.2365 67.1258 53.3636 67.789 54.0113C68.3428 54.55 68.355 55.1553 68.355 56.4749ZM20.7444 58.5208C20.4584 58.8174 20.3124 59.1927 20.3124 59.6527C20.3124 60.1127 20.4523 60.488 20.7444 60.7846C21.2008 61.2507 21.8093 61.3173 22.3935 61.3173H27.3043V58.0002H22.3935C21.8032 58.0002 21.1947 58.0668 20.7444 58.5329V58.5208ZM27.1826 61.1841H22.3996C21.8398 61.1841 21.2617 61.1236 20.8357 60.6938C20.574 60.4275 20.4402 60.0764 20.4402 59.6527C20.4402 59.229 20.574 58.8779 20.8357 58.6116C21.2617 58.1818 21.8337 58.1213 22.3996 58.1213H27.1826V61.1841ZM13.0406 53.1154H0.517241V62.4916H2.9574V54.7316H7.49696V62.4916H9.84584V54.7316H12.2738C13.0101 54.7316 13.5091 54.9071 13.8864 55.2945C14.2211 55.6456 14.3732 56.0935 14.3732 56.7654V62.4976H16.8438V55.8877C16.8438 54.0537 16.2535 53.1275 13.0284 53.1275L13.0406 53.1154ZM16.7282 62.3645H14.5132V56.7594C14.5132 56.0572 14.3489 55.579 13.9899 55.2037C13.5882 54.7861 13.0649 54.6045 12.286 54.6045H9.73022V62.3645H7.63692V54.6045H2.84178V62.3645H0.64503V53.2425H13.0345C16.1684 53.2425 16.7221 54.09 16.7221 55.8756V62.3584L16.7282 62.3645ZM37.8864 53.1154H31.6065V54.6468H35.7931L37.8864 53.1154ZM31.7343 54.5197V53.2425H37.503L35.7566 54.5197H31.7343ZM53.7383 53.4665C52.9047 53.2002 52.1075 53.1154 50.355 53.1154H41.5984L29.4828 61.9831V56.4809C29.4828 55.125 29.4706 54.4955 28.8803 53.9265C28.1866 53.2546 27.1826 53.1154 25.789 53.1154H19.1014V54.5682H25.0953C25.7708 54.5682 27.1704 54.5682 27.1704 56.0512V57.1286H21.9797C21.0669 57.1286 20.501 57.177 20.0142 57.2981C18.6633 57.6249 18.1765 58.8598 18.1704 59.8101C18.1643 60.8452 18.7059 62.0255 19.9412 62.3403C20.1481 62.3887 20.9209 62.4916 22.3631 62.4916H31.8621L44.069 53.636V62.4916H50.3611C52.1136 62.4916 52.9107 62.4068 53.7444 62.1405C54.6146 61.8318 55.0345 61.4868 55.4118 60.7665C55.8316 59.9675 55.8803 58.6903 55.8803 57.8005C55.8803 56.9107 55.8316 55.6395 55.4118 54.8345C55.0345 54.1142 54.6085 53.7692 53.7444 53.4605L53.7383 53.4665ZM55.2901 60.712C54.931 61.396 54.5294 61.7289 53.6957 62.0255C52.8742 62.2858 52.0953 62.3645 50.355 62.3645H44.1907V53.3878L31.8134 62.3645H22.357C20.927 62.3645 20.1724 62.2676 19.9655 62.2192C18.8032 61.9226 18.286 60.7907 18.2921 59.8101C18.2921 58.9021 18.7606 57.7278 20.0325 57.4191C20.5071 57.3041 21.0669 57.2557 21.9675 57.2557H27.286V56.0512C27.286 54.441 25.7404 54.441 25.0832 54.441H19.217V53.2425H25.7769C27.14 53.2425 28.1197 53.3697 28.7769 54.0173C29.3306 54.5561 29.3428 55.1614 29.3428 56.4809V62.2313L41.6288 53.2425H50.3489C52.0892 53.2425 52.8682 53.3212 53.6957 53.5876C54.5233 53.8781 54.9249 54.211 55.284 54.9011C55.6917 55.6759 55.7343 56.9288 55.7343 57.8065C55.7343 58.6842 55.6856 59.9372 55.284 60.712H55.2901ZM52.6065 55.004C52.1014 54.6287 51.5659 54.5258 50.1055 54.5258H46.3813V61.0933H50.1055C51.5598 61.0933 52.1014 60.9904 52.6065 60.6151C53.4341 60.0038 53.5862 59.1564 53.5862 57.8126C53.5862 56.4688 53.428 55.6274 52.6065 55.01V55.004ZM52.5335 60.5062C52.0527 60.8633 51.5355 60.9602 50.1116 60.9602H46.5152V54.6468H50.1116C51.5355 54.6468 52.0588 54.7437 52.5335 55.1008C53.3185 55.6819 53.4645 56.4991 53.4645 57.8005C53.4645 59.1019 53.3185 59.919 52.5335 60.5001V60.5062ZM59.6775 58.5268C59.3915 58.8174 59.2454 59.1987 59.2454 59.6588C59.2454 60.1188 59.3915 60.4941 59.6775 60.7907C60.1339 61.2628 60.8519 61.3233 61.4178 61.3233H66.2434V58.0063H61.4178C60.8519 58.0063 60.1339 58.0668 59.6775 58.5389V58.5268ZM66.1156 61.1902H61.4178C60.8763 61.1902 60.1947 61.1357 59.7688 60.6999C59.5071 60.4335 59.3732 60.0825 59.3732 59.6588C59.3732 59.235 59.501 58.884 59.7688 58.6176C60.1947 58.1818 60.8702 58.1273 61.4178 58.1273H66.1156V61.1902Z",
    fill: "url(#paint1_linear_402_5155)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5154 46.3121C25.0042 46.3121 17.1908 44.1572 12.5174 40.253C7.97178 36.4517 5.62898 30.8405 5.35515 23.0866C5.10565 15.9198 8.06306 9.10406 13.0773 5.2967C17.8298 1.68909 24.6026 0.00634766 34.3876 0.00634766C44.1726 0.00634766 51.2862 1.69514 55.8562 5.32697C60.7182 9.1888 63.7243 16.174 63.5113 23.1289C63.274 30.8829 60.9677 36.3064 56.2517 40.1864C51.4505 44.139 43.7345 46.3121 34.5154 46.3121ZM34.485 3.31736C31.8196 3.31736 29.2578 3.53527 27.2862 3.94082C23.9515 4.61876 22.2111 5.30881 19.8196 6.91286C13.6614 11.035 12.3714 17.8628 12.3714 22.8687C12.3714 30.4955 14.9393 36.0522 19.9961 39.3813C23.13 41.4394 27.6087 42.3594 34.5154 42.3594C40.9353 42.3594 44.8724 41.5302 48.56 39.4116C52.1929 37.3233 56.5255 32.7533 56.5255 22.8263C56.5255 15.5324 54.0367 10.1815 49.1199 6.91286C46.8136 5.38144 45.3349 4.7035 41.629 3.94082C39.6817 3.54132 37.1442 3.32341 34.485 3.32341V3.31736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5882 33.6005C34.1379 33.6005 34.0162 33.3221 33.6024 32.396C33.4199 31.9844 33.14 31.3548 32.714 30.5195C31.0041 27.1298 27.998 24.3757 24.4746 22.9653C23.4828 22.5658 22.1075 22.1603 20.7809 21.7729H20.7627C18.0426 20.9618 14.9635 20.0478 12.6389 18.6737L12.5538 17.221V13.5347L15.0365 11.8701C15.1886 11.973 16.3935 12.7418 18.0852 13.5044C18.8519 13.8495 19.6978 14.2187 20.5619 14.6L20.6105 14.6242C23.5558 15.9135 26.8905 17.3784 28.2414 18.3469C30.5051 19.963 32.6045 22.3237 34.0041 24.8297C34.2049 25.1868 34.3692 25.3139 34.4604 25.3139C34.5335 25.3139 34.7221 25.205 34.929 24.7933C36.3469 22.0392 38.86 19.5151 40.7282 18.2258C42.5294 16.991 45.5781 15.7743 48.2677 14.7029H48.2921C49.5335 14.2005 50.7018 13.7345 51.5903 13.3289C52.9777 12.6933 53.9026 12.0638 53.9817 12.0093L56.3306 13.456V17.221L56.2454 18.595C54.6694 19.509 53.714 20.0599 49.8438 21.0526L49.6491 21.101C42.6085 22.8806 38.1116 26.0524 36.286 30.5256C36.0669 31.0582 35.8966 31.5304 35.7627 31.9057L35.7383 31.9783C35.3489 33.0618 35.1542 33.6005 34.5822 33.6005H34.5882Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8519 42.0504C21.7546 41.203 12.3347 38.0009 12.3347 22.608C12.3347 13.8069 16.2961 3.27464 34.5152 3.27464C50.9574 3.27464 56.574 12.0697 56.574 22.5778C56.574 37.0748 48.14 40.8579 41.1785 41.9959C37.789 42.5528 31.8256 42.6073 27.8519 42.0564V42.0504ZM60.5659 22.7049C60.5659 10.9681 55.0162 1.25293 34.5822 1.25293C13.1197 1.25293 8.59838 13.02 8.59838 22.7291C8.59838 38.9754 19.5578 42.922 27.5294 43.8602C31.5639 44.3324 37.4057 44.3021 41.1481 43.8663C49.0467 42.9462 60.572 39.0299 60.572 22.7049H60.5659Z",
    fill: "url(#paint2_linear_402_5155)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8519 42.0504C21.7546 41.203 12.3347 38.0009 12.3347 22.608C12.3347 13.8069 16.2961 3.27464 34.5152 3.27464C50.9574 3.27464 56.574 12.0697 56.574 22.5778C56.574 37.0748 48.14 40.8579 41.1785 41.9959C37.789 42.5528 31.8256 42.6073 27.8519 42.0564V42.0504ZM60.5659 22.7049C60.5659 10.9681 55.0162 1.25293 34.5822 1.25293C13.1197 1.25293 8.59838 13.02 8.59838 22.7291C8.59838 38.9754 19.5578 42.922 27.5294 43.8602C31.5639 44.3324 37.4057 44.3021 41.1481 43.8663C49.0467 42.9462 60.572 39.0299 60.572 22.7049H60.5659Z",
    fill: "url(#paint3_linear_402_5155)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6126 1.59814V3.06903C18 3.1114 12.3408 11.8399 12.3408 22.9169C12.3408 33.0195 16.7282 38.1464 21.6998 40.4465C27.2799 43.0251 33.7607 42.5711 30.712 43.7333C29.9696 44.0178 29.3489 44.4779 26.6653 44.1691C18.7667 43.2491 8.66532 39.3751 8.66532 23.0501C8.66532 11.3193 14.215 1.61025 34.6126 1.59814Z",
    fill: "url(#paint4_linear_402_5155)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.3651 23.1833C63.3651 29.4301 61.2535 35.9068 56.1907 40.0653C50.8905 44.4234 42.6572 46.2636 34.4239 46.2636C25.6065 46.2636 17.9757 44.605 12.2252 39.7929C7.64909 35.9674 5.44625 29.1456 5.44625 23.1046C5.44625 16.525 7.57607 9.54585 13.1258 5.32688C18.2191 1.46504 27.2799 0.0546875 34.3935 0.0546875C42.5659 0.0546875 50.4888 1.38636 55.7769 5.58111C60.9128 9.66086 63.3651 16.7247 63.3651 23.1833ZM60.4442 22.9654C60.4442 12.0579 54.0487 1.51347 34.4604 1.51347C12.998 1.51347 8.47668 13.2806 8.47668 22.9896C8.47668 39.5507 19.8621 43.3278 27.8641 44.1692C32.1846 44.6232 36.5172 44.6777 41.2393 44.1511C45.9675 43.6305 60.4503 40.489 60.4503 22.9654H60.4442Z",
    fill: "url(#paint5_linear_402_5155)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.07911 17.578C10.071 14.7452 11.3245 10.0601 14.9878 6.82781C19.1197 3.18388 26.3732 1.89459 28.503 1.65247C27.6694 1.16822 27.2373 1.06532 26.0081 0.671875C20.0385 1.54351 14.9878 3.18389 11.3793 6.96098C7.76471 10.7381 6.23732 15.4655 5.75659 18.6252C7.00406 18.1712 7.50913 18.0622 9.07911 17.5841V17.578Z",
    fill: "url(#paint6_linear_402_5155)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2536 2.48193C41.1785 2.48193 47.7688 3.65622 51.9006 8.94658C45.5659 1.14421 24.1765 0.962622 17.1237 8.94658C21.2556 4.25547 27.3286 2.48193 34.2536 2.48193Z",
    fill: "url(#paint7_linear_402_5155)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5152 43.1097C26.9513 43.1097 22.503 42.1594 18.7059 38.7031C18.2312 38.2733 18.2617 38.2975 18.8032 38.6849C19.8986 39.4718 21.2191 40.3253 22.6917 40.8701C26.1602 42.1533 30.5112 42.5165 34.5335 42.5165C38.5558 42.5165 42.0304 42.1049 45.1339 41.1303C47.3732 40.4282 49.1014 39.1994 50.6592 38.0494C51.2191 37.6317 51.2738 37.6559 50.7688 38.0917C46.6187 41.6509 41.7505 43.1036 34.5152 43.1036V43.1097Z",
    fill: "url(#paint8_linear_402_5155)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.2596 33.1401C61.6187 32.3411 61.5943 32.4017 61.7525 31.8932C61.8195 31.6693 61.6917 32.0264 61.5456 32.3048C61.3509 32.6741 61.3935 32.6438 61.1014 33.0554C60.7972 33.4731 60.712 33.5215 60.1521 33.8726C59.7079 34.151 59.1481 34.3386 58.2657 34.8168C58.0406 34.944 57.931 35.0287 57.4625 35.634C57.1278 36.0638 56.7688 36.5601 56.5801 36.772C56.002 37.4317 54.4807 38.6484 53.641 39.3748C52.9108 40.0103 53.1542 40.0527 54.1886 39.7016C55.1136 39.3869 56.4828 38.8179 57.2921 38.485C57.8033 38.2731 58.2231 37.922 58.3935 37.7223C59.3915 36.5662 60.5659 34.6837 61.2657 33.1341L61.2596 33.1401Z",
    fill: "url(#paint9_linear_402_5155)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.59838 22.9408C8.59838 17.6928 10.4665 10.8529 14.9635 6.88209C19.0953 3.23816 26.1542 1.87017 28.284 1.62805C27.4503 1.14381 27.0122 1.04091 25.789 0.647461C19.8195 1.5191 14.7505 3.25027 11.1359 7.02131C7.27789 11.0466 5.47059 17.6565 5.3854 22.0873C6.43814 22.39 7.22312 22.6079 8.59838 22.9347V22.9408Z",
    fill: "url(#paint10_linear_402_5155)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4909 3.32928C37.1562 3.32928 39.6876 3.54719 41.6288 3.94669C45.3408 4.70937 46.8134 5.38731 49.1197 6.91873C54.0304 10.1813 56.5193 15.5322 56.5193 22.8201C56.5193 32.741 52.1866 37.311 48.5538 39.3993C44.8661 41.5179 40.929 42.3471 34.5152 42.3471C27.6085 42.3471 23.1298 41.4271 19.9959 39.3751C14.9391 36.052 12.3773 30.4953 12.3773 22.8685C12.3773 17.8687 13.6673 11.0408 19.8195 6.91873C22.211 5.32073 23.9513 4.62463 27.286 3.95274C29.2637 3.55324 31.8195 3.32928 34.4848 3.32928H34.4909ZM34.4909 3.2627C31.9168 3.2627 29.3306 3.4685 27.2738 3.88616C23.9696 4.55805 22.1927 5.25414 19.789 6.86425C13.9655 10.7624 12.3164 17.1726 12.3164 22.8685C12.3164 30.6951 14.9635 36.1367 19.9655 39.4235C23.5923 41.8084 28.789 42.4077 34.5152 42.4077C40.2414 42.4077 44.6227 41.7358 48.5903 39.4538C53.1785 36.8147 56.5862 31.6393 56.5862 22.8201C56.5862 16.077 54.4138 10.3569 49.1562 6.86425C46.789 5.29046 45.2982 4.63673 41.6471 3.88616C39.6389 3.47455 37.071 3.26875 34.4909 3.26875V3.2627Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4909 3.26256C37.071 3.26256 39.645 3.46836 41.6471 3.87997C45.2982 4.63055 46.7951 5.29033 49.1562 6.85806C54.4138 10.3507 56.5862 16.0708 56.5862 22.8139C56.5862 31.6331 53.1785 36.8085 48.5903 39.4476C44.6227 41.7296 40.43 42.4015 34.5152 42.4015C28.6004 42.4015 23.5923 41.8022 19.9655 39.4174C14.9635 36.1245 12.3164 30.6828 12.3164 22.8623C12.3164 17.1664 13.9655 10.7562 19.789 6.85806C22.1927 5.24796 23.9696 4.55186 27.2738 3.87997C29.3306 3.46231 31.9108 3.25651 34.4909 3.25651V3.26256ZM34.4909 3.12939C31.8134 3.12939 29.2394 3.35336 27.2495 3.75286C23.8905 4.43685 22.1318 5.13295 19.716 6.74911C13.4909 10.9136 12.1826 17.808 12.1826 22.8623C12.1826 30.5557 14.7748 36.1669 19.8925 39.5324C23.0568 41.6146 27.5659 42.5407 34.5152 42.5407C40.9716 42.5407 44.9392 41.7054 48.6572 39.5687C52.3327 37.4562 56.714 32.8316 56.714 22.8199C56.714 15.4594 54.1947 10.0541 49.2292 6.75516C46.9047 5.21164 45.4138 4.52159 41.6714 3.75286C39.7181 3.35336 37.1684 3.12939 34.4909 3.12939Z",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3874 0.0665834C42.8641 0.0665834 50.6288 1.24693 55.8195 5.3751C61.0162 9.50327 63.645 16.7609 63.4564 23.1286C63.2373 30.3318 61.2779 35.9792 56.215 40.1437C50.9148 44.5019 42.7485 46.2573 34.5152 46.2573C26.2819 46.2573 17.8357 44.623 12.5538 40.2103C7.72819 36.179 5.66532 30.247 5.40974 23.0863C5.16024 16.0527 7.96552 9.24904 13.1075 5.34483C18.7911 1.02902 26.8661 0.0665834 34.3874 0.0665834ZM34.3874 0C24.5963 0 17.8296 1.68274 13.0771 5.29035C8.0568 9.10377 5.09939 15.9195 5.34888 23.0863C5.62272 30.8342 7.96552 36.4574 12.5172 40.2587C17.1907 44.169 25.0041 46.3239 34.5213 46.3239C44.0385 46.3239 51.4564 44.1508 56.2576 40.1982C60.9797 36.3122 63.286 30.8947 63.5233 23.1347C63.7363 16.1798 60.7302 9.18851 55.8621 5.32667C51.2921 1.6888 44.4645 0 34.3874 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3874 0.193714C44.4158 0.193714 51.2069 1.8704 55.7404 5.47196C60.5538 9.29748 63.5294 16.2222 63.3225 23.1226C63.0913 30.816 60.8032 36.1972 56.1298 40.0409C51.3651 43.9632 43.6856 46.1241 34.5152 46.1241C25.3448 46.1241 17.2819 43.9874 12.6389 40.1074C8.1359 36.3424 5.81744 30.7676 5.54361 23.0802C5.29412 15.974 8.22718 9.21879 13.1927 5.4417C17.9087 1.86435 24.645 0.193714 34.3874 0.193714ZM34.3874 0.0605469C26.8661 0.0665999 18.7911 1.02903 13.1136 5.33879C7.9716 9.243 5.16633 16.0466 5.41582 23.0802C5.66531 30.2349 7.73428 36.1669 12.5598 40.2043C17.8418 44.623 26.2515 46.2513 34.5213 46.2513C42.7911 46.2513 50.9209 44.4959 56.2211 40.1377C61.284 35.9732 63.2434 30.3257 63.4625 23.1226C63.6572 16.7548 61.0223 9.49723 55.8256 5.36906C50.6288 1.24694 42.8641 0.0665999 34.3874 0.0665999V0.0605469Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4118 4.17646C50.641 4.34595 55.0467 5.29627 56.5436 6.19818C57.9675 7.05771 57.7241 7.08797 57.7241 7.08797L55.0771 8.08672C55.0771 8.08672 53.2211 6.02264 49.4118 4.17041V4.17646Z",
    fill: "url(#paint11_linear_402_5155)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2596 4.1098C16.6369 4.72721 13.1075 5.62306 11.714 6.52496C11.0568 6.94867 9.24949 9.29725 9.24949 9.29725L11.8114 7.17869C13.0588 6.85183 13.1258 6.78524 14.0751 6.56128C15.1339 6.30705 15.7363 6.22836 16.9047 5.44752C18.073 4.66668 21.8824 3.49239 19.2536 4.11585L19.2596 4.1098Z",
    fill: "url(#paint12_linear_402_5155)",
    fillOpacity: 0.42
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.57 44.6654C31.9838 44.6654 29.3306 44.4717 26.2028 44.0601C19.5396 43.1824 8.36714 39.2721 8.36714 22.9108C8.36714 13.2622 13.0284 6.05913 21.1643 3.14157C24.6876 1.87649 29.1968 1.23486 34.5517 1.23486C44.1785 1.23486 51.0548 3.57134 55.5578 8.37745C58.9473 11.9911 60.5964 16.7367 60.5964 22.8805C60.5964 38.3823 50.3489 43.0069 41.7444 44.1569C39.2008 44.4959 36.9189 44.6533 34.5639 44.6533L34.57 44.6654ZM34.5517 1.62831C29.2394 1.62831 24.7789 2.25783 21.2982 3.5108C13.3327 6.36784 8.76268 13.4378 8.76268 22.9108C8.76268 38.1705 18.2738 42.6255 26.2576 43.6727C32.1846 44.4535 36.3895 44.4838 41.6957 43.7756C50.142 42.6437 60.2069 38.1039 60.2069 22.8866C60.2069 16.8456 58.5943 12.1909 55.2718 8.64983C50.8418 3.92846 44.0629 1.62831 34.5456 1.62831H34.5517Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M34.57 44.7318C31.9777 44.7318 29.3185 44.5381 26.1968 44.1325C21.3164 43.4909 17.3367 41.7779 14.3489 39.048C10.3387 35.3738 8.30629 29.9503 8.30629 22.9166C8.30629 13.2378 12.9858 6.0105 21.146 3.08688C24.6815 1.8218 29.1907 1.18018 34.5578 1.18018C44.2089 1.18018 51.0974 3.5227 55.6126 8.34697C59.0142 11.9788 60.6694 16.7365 60.6694 22.8985C60.6694 38.4487 50.3854 43.0853 41.7627 44.2415C39.2191 44.5804 36.931 44.7378 34.5761 44.7378L34.57 44.7318ZM34.5517 1.30729C29.2028 1.30729 24.7059 1.94891 21.1886 3.20794C13.0832 6.1134 8.44016 13.2923 8.44016 22.9166C8.44016 29.9079 10.4604 35.3072 14.4402 38.9511C17.4037 41.6629 21.3651 43.3638 26.215 43.9994C29.3306 44.411 31.9899 44.5986 34.57 44.5986C36.9189 44.5986 39.2008 44.4412 41.7383 44.1023C50.3124 42.9582 60.5355 38.3458 60.5355 22.8864C60.5355 16.7607 58.8925 12.0333 55.5152 8.42566C51.0183 3.63166 44.1663 1.30124 34.5517 1.30124V1.30729Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.46045 32.3959C7.63692 32.7652 7.8073 33.316 8.48885 33.6186C9.01826 33.8547 9.43813 34.0242 9.96755 34.23C10.8134 34.5569 11.4645 35.6827 12.0122 36.4091C12.5538 37.1173 14.2819 38.7092 15.14 39.4053C16.4239 40.4525 18.7972 41.8568 20.6045 42.5953C20.7323 42.6498 25.6795 44.6957 25.1318 45.1739C24.9736 45.3131 20.4219 44.0299 20.2089 43.9693C16.3083 42.789 12.1826 40.4344 9.43814 36.5181C9.06694 35.9854 7.69777 33.5157 7.39351 32.517C7.19878 31.8814 7.2353 31.9359 7.46045 32.408V32.3959Z",
    fill: "url(#paint13_linear_402_5155)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.8905 17.6444C58.8925 14.8176 57.645 10.1326 53.9817 6.89422C49.8499 3.25029 42.5964 1.96099 40.4665 1.71887C41.2941 1.23463 41.7323 1.13173 42.9615 0.738281C48.931 1.60992 54 3.33503 57.6146 7.11213C60.6511 10.2839 61.9838 13.9884 62.6653 17.0088C61.6187 17.3115 61.2657 17.3115 59.8905 17.6384V17.6444Z",
    fill: "url(#paint14_linear_402_5155)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7546 19.3755C42.7546 19.3755 42.7059 19.3997 42.6876 19.4058C41.3063 20.0898 34.6673 27.3353 34.503 27.4987C34.3387 27.6621 27.2434 21.942 27.1095 21.712C26.9817 21.482 14.8966 17.1541 14.8966 17.1541L11.9757 16.8938C11.9757 16.8938 12.1704 17.6444 12.925 18.6855C15.9615 20.5922 21.9736 21.8875 25.0832 23.1345C28.8499 24.6417 31.4726 28.0495 32.8418 30.4828C33.7607 32.1172 33.9371 33.5517 34.5822 33.5517C35.2272 33.5517 35.5801 32.0324 36.0122 31.0518C38.1298 26.1912 40.7282 23.2858 49.8438 20.9856C55.4604 19.5692 56.2759 18.401 56.2759 18.401L57.4807 15.5742C57.4807 15.5742 44.4645 18.6249 42.7667 19.3695L42.7546 19.3755Z",
    fill: "url(#paint15_linear_402_5155)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5071 16.0284C11.9878 17.2874 12.7972 18.6857 12.7972 18.6857C12.7972 18.6857 14.2028 19.4181 15.998 20.0052C20.0446 21.3369 25.1501 22.0814 26.6227 22.7775C31.9229 25.3016 33.146 27.6684 34.3874 29.7385C33.8398 28.3705 33.359 27.0873 31.4544 24.7326C28.7039 21.3308 26.9331 20.5439 22.9899 19.0973C21.6329 18.6009 19.7404 17.8564 17.4523 17.009C15.1643 16.1615 12.2799 14.6483 10.5091 13.4679C10.4848 13.4498 11.1055 14.9872 11.5071 16.0223V16.0284Z",
    fill: "url(#paint16_linear_402_5155)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9047 20.8529C38.9817 19.6484 39.8154 18.8373 41.8357 17.6448C45.5781 15.4355 51.3895 14.237 55.2536 11.2831C57.8337 9.30979 58.5456 8.31104 58.5456 8.31104C58.5456 8.31104 58.8316 9.15846 58.8682 10.2541C58.8925 10.8654 58.9412 11.4526 58.8621 12.1426C58.789 12.7842 58.643 13.3351 58.6308 13.3472C56.8296 14.5457 54.3164 15.956 51.998 16.8156C49.6795 17.6751 47.501 18.4257 46.1258 18.9341C40.1805 21.1495 37.5943 24.509 35.6531 27.9652C34.7525 29.5754 34.5274 29.7812 34.5274 29.7569C34.5274 29.6904 34.5152 25.9617 34.5152 25.4109C34.5578 25.4109 34.6126 25.4109 34.8742 24.9569C35.3915 24.0731 36.5659 22.3722 37.9107 20.859L37.9047 20.8529Z",
    fill: "url(#paint17_linear_402_5155)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.4361 13.4802C56.6653 14.6666 53.5801 16.083 51.2982 16.9305C49.0101 17.7779 47.6653 18.1532 46.3083 18.6495C42.4807 20.0538 40.0527 21.5187 37.2353 24.9992C35.3306 27.3538 35.0203 28.6189 34.57 29.666C34.57 30.2774 34.6065 33.4371 34.6065 33.4371C34.6065 33.4371 34.8134 33.4795 34.9655 33.2313C35.0325 33.1344 34.9777 32.1175 34.9594 31.3791C34.9473 30.7677 34.9959 30.5982 35.3245 29.999C35.5801 29.5329 35.8722 29.0063 36.0669 28.6976C37.6673 26.2219 40.6917 24.3454 43.6552 22.929C46.2475 21.6942 50.1542 20.871 52.7525 20.0115C54.5416 19.4243 56.1968 18.6011 56.1968 18.6011C56.1968 18.6011 56.8783 17.6145 57.359 16.3554C57.7607 15.3204 58.4544 13.4621 58.43 13.4742L58.4361 13.4802Z",
    fill: "url(#paint18_linear_402_5155)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.925 24.9989C34.1866 25.465 34.4118 25.4105 34.5091 25.4105C34.5091 26.0945 34.5274 29.6658 34.5274 29.7324C34.5274 29.7506 34.4544 29.5024 33.5477 27.8923C29.9635 21.5063 26.5132 20.2776 23.2759 19.073C21.9006 18.5645 19.3448 17.584 17.0264 16.7244C14.7079 15.8649 12.0974 14.4061 10.2961 13.2076C10.1927 13.141 10.3205 12.7657 10.2475 12.1241C10.1684 11.4341 10.1866 10.6593 10.2049 10.0479C10.2414 8.95232 10.4665 8.15332 10.4665 8.15332C10.4665 8.15332 11.6775 9.87238 14.4219 11.6096C16.0953 12.6749 18.146 13.7524 20.1481 14.5816C22.57 15.5864 25.0527 16.6699 27.1035 17.8805C29.1237 19.073 30.1643 20.0657 31.2353 21.2763C32.5862 22.7896 33.426 24.097 33.925 24.9929V24.9989Z",
    fill: "url(#paint19_linear_402_5155)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0507 19.1882C30.6937 20.9072 31.4118 21.7123 32.5497 23.8853C33.3347 25.3744 33.4929 25.4954 34.4726 29.2786L34.2231 25.5499C34.2231 25.5499 32.8661 23.4314 32.0142 22.36C31.1866 21.3249 30.0122 20.0114 29.0507 19.1821V19.1882Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5882 33.6062C34.1379 33.6062 34.0101 33.3278 33.5903 32.3956C33.3895 31.9477 33.1156 31.3363 32.7018 30.5192C30.9919 27.1295 27.9919 24.3814 24.4686 22.971C23.4888 22.5776 22.1744 22.1902 20.7809 21.7786C18.0548 20.9735 14.9635 20.0595 12.6329 18.6794L12.6998 18.5644C15.0122 19.9385 18.0974 20.8525 20.8174 21.6575C22.217 22.0691 23.5375 22.4626 24.5233 22.856C28.071 24.2785 31.1014 27.0508 32.8235 30.4708C33.2373 31.2879 33.5112 31.9053 33.712 32.3533C34.144 33.3096 34.2353 33.4912 34.5882 33.4912C35.0751 33.4912 35.2515 33.007 35.6288 31.9538C35.7688 31.5603 35.9452 31.064 36.1826 30.495C37.3631 27.6016 39.6694 25.2228 43.0406 23.425C45.7485 21.9783 48.3712 21.3125 49.6308 20.9978L49.8256 20.9493C53.6836 19.9627 54.6268 19.4119 56.1968 18.5039L56.2637 18.6189C54.6876 19.5329 53.7323 20.0898 49.856 21.0764L49.6613 21.1249C42.6207 22.9045 38.1298 26.0763 36.3043 30.5434C36.073 31.1063 35.8966 31.5966 35.7566 31.9961C35.3671 33.0796 35.1724 33.6244 34.5943 33.6244L34.5882 33.6062Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6004 33.5035C34.1744 33.5035 34.0527 33.2251 33.645 32.311C33.4442 31.851 33.1643 31.2215 32.7383 30.3801C31.0223 26.9844 28.0162 24.2242 24.4868 22.8138C23.5193 22.4264 22.2292 22.0572 20.854 21.6638C18.1034 20.8769 14.9817 19.981 12.6146 18.5101L12.6511 18.4556C15.0122 19.9265 18.1217 20.8163 20.8722 21.6032C22.2475 21.9967 23.5436 22.3659 24.5112 22.7533C28.0527 24.1697 31.0771 26.942 32.7992 30.3499C33.2252 31.1912 33.5051 31.8207 33.7059 32.2808C34.1075 33.1887 34.217 33.4369 34.6004 33.4369C35.0994 33.4369 35.2819 32.9224 35.6471 31.8934C35.7931 31.4757 35.9757 30.9612 36.2191 30.362C37.3996 27.4747 39.6937 25.1079 43.0588 23.3102C45.7667 21.8635 48.3834 21.2037 49.643 20.8829L49.8377 20.8345C53.7201 19.8418 54.7911 19.2789 56.355 18.377L56.3915 18.4314C54.8702 19.3091 53.7444 19.9023 49.856 20.895L49.6613 20.9434C42.6146 22.7291 38.1116 25.9069 36.286 30.3801C36.0426 30.9794 35.86 31.4939 35.714 31.9115C35.3428 32.9648 35.1542 33.4974 34.6065 33.4974L34.6004 33.5035Z",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5152 29.7928C34.4361 29.7928 34.3631 29.7444 34.3327 29.6718C34.3205 29.6536 33.5294 27.7893 31.9108 25.5012C30.8702 24.0303 29.7992 23.0679 28.8499 22.2144L28.7891 22.16C27.8945 21.3488 26.8235 20.5256 23.6227 19.3271C23.1116 19.1334 22.4118 18.8853 21.645 18.6068C19.9533 18.0015 17.854 17.2449 16.8012 16.7788C16.1866 16.5064 15.7059 16.3006 15.3103 16.1311C13.6552 15.4229 13.357 15.2958 10.43 13.4496C10.3387 13.3952 10.3083 13.2741 10.3692 13.1772C10.43 13.0865 10.5517 13.0562 10.643 13.1167C13.5456 14.9447 13.8438 15.0658 15.4686 15.7679C15.8702 15.9374 16.3509 16.1432 16.9655 16.4156C18.0061 16.8757 20.0994 17.6262 21.785 18.2376C22.5517 18.516 23.2515 18.7642 23.7627 18.9579C27.0304 20.1867 28.1318 21.0341 29.0568 21.8694L29.1176 21.9239C30.0791 22.7895 31.1684 23.7761 32.2333 25.2773C33.426 26.9661 34.1805 28.4248 34.5091 29.1088C34.8134 28.4248 35.5375 26.9661 36.8519 25.1744C37.9777 23.6369 39.3043 22.2629 40.6795 21.2036C42.2252 20.0111 44.0507 19.2727 45.785 18.6129C46.8742 18.2013 47.7444 17.8986 48.5903 17.602C50.1298 17.0693 51.4625 16.6093 53.4949 15.6771C56.8174 14.1639 58.3327 13.1167 58.3509 13.1046C58.4361 13.0441 58.5639 13.0622 58.6247 13.153C58.6856 13.2438 58.6673 13.3649 58.5761 13.4254C58.5152 13.4678 57.0243 14.4968 53.6653 16.0343C51.6085 16.9725 50.2698 17.4325 48.7241 17.9713C47.8844 18.2618 47.0142 18.5644 45.931 18.9761C44.2272 19.6237 42.4321 20.3501 40.929 21.5123C39.5781 22.5534 38.2819 23.8972 37.1805 25.4044C35.4158 27.8074 34.716 29.6476 34.7099 29.6657C34.6795 29.7384 34.6126 29.7928 34.5274 29.7928H34.5152Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4726 25.5679C34.3083 25.5679 34.1136 25.3742 33.9067 25.0171C32.5071 22.5233 30.4199 20.1747 28.1744 18.5706C26.8235 17.6082 23.4767 16.1373 20.5193 14.842C19.6308 14.4546 18.7972 14.0853 18.0365 13.7464C16.2353 12.9353 14.8114 11.991 14.7931 11.9849L14.8661 11.876C14.8661 11.876 16.3022 12.8202 18.0913 13.6253C18.8458 13.9643 19.6856 14.3335 20.568 14.7209C23.5314 16.0163 26.8844 17.4871 28.2475 18.4617C30.5051 20.0718 32.6106 22.4385 34.0162 24.9505C34.217 25.3077 34.3813 25.4348 34.4665 25.4348C34.5396 25.4348 34.7221 25.3258 34.929 24.9203C36.3469 22.1661 38.8661 19.636 40.7282 18.3527C42.5294 17.1119 45.5781 15.9012 48.2738 14.8238C49.5213 14.3275 50.6957 13.8553 51.5903 13.4498C53.0385 12.7839 54.2008 11.997 54.2069 11.9849L54.2799 12.0939C54.2799 12.0939 53.0994 12.8929 51.639 13.5648C50.7444 13.9764 49.5639 14.4485 48.3164 14.9449C45.6329 16.0163 42.5903 17.2269 40.7951 18.4556C38.9452 19.7268 36.4442 22.2388 35.0385 24.9747C34.8499 25.344 34.6369 25.5619 34.4605 25.5619L34.4726 25.5679Z",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4726 25.4349C34.3083 25.4349 34.1136 25.2472 33.9067 24.884C32.5071 22.3902 30.4199 20.0416 28.1744 18.4376C26.8235 17.4751 23.4767 16.0042 20.5193 14.7089C19.6308 14.3215 18.7972 13.9523 18.0365 13.6133C16.2353 12.8022 14.9757 11.9729 14.9635 11.9669L15.0365 11.8579C15.0365 11.8579 16.3022 12.6872 18.0913 13.4922C18.8458 13.8312 19.6795 14.2004 20.568 14.5878C23.5314 15.8892 26.8844 17.3541 28.2475 18.3286C30.5051 19.9387 32.6105 22.3054 34.0162 24.8175C34.217 25.1746 34.3813 25.3017 34.4665 25.3017C34.5396 25.3017 34.7221 25.1927 34.929 24.7872C36.3469 22.0331 38.8661 19.5029 40.7282 18.2197C42.5294 16.9848 45.5781 15.7682 48.2677 14.6968C49.5152 14.2004 50.6957 13.7283 51.5842 13.3227C53.0325 12.6569 53.9696 12.0092 53.9817 12.0032L54.0548 12.1121C54.0548 12.1121 53.0994 12.7719 51.6389 13.4438C50.7444 13.8554 49.5639 14.3275 48.3164 14.8239C45.6329 15.8953 42.5903 17.1059 40.8012 18.3347C38.9513 19.6058 36.4503 22.1178 35.0446 24.8538C34.856 25.223 34.643 25.4349 34.4665 25.4349H34.4726Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5578 29.0609L34.4665 25.5864H34.5882L34.5578 29.0609Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1359 8.087C16.0588 6.08345 18.4625 4.52782 21.2982 3.51696C24.7789 2.27003 29.2394 1.63446 34.5517 1.63446C43.789 1.63446 50.4523 3.80145 54.8824 8.25043C54.8824 8.25043 54.9371 8.2928 54.9858 8.34728C55.0832 8.2928 55.2596 8.11727 55.3022 8.11727C55.2475 8.06279 55.1988 8.02042 55.1805 8.00226C50.6714 3.45643 43.9108 1.24707 34.5456 1.24707C29.1907 1.24707 24.6815 1.88869 21.1582 3.15378C18.2191 4.20701 15.7302 5.82317 13.7586 7.91146C13.7586 7.91146 13.7282 7.92962 13.7404 7.94173C13.7586 7.96594 13.8256 7.99621 13.8682 8.02647C13.9351 8.0749 14.0081 8.14148 14.0568 8.15964C14.0811 8.16569 14.1176 8.10516 14.1298 8.09305L14.1359 8.087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9797 8.42585L54.9432 8.39559C54.9067 8.36532 54.8763 8.33506 54.858 8.3169C54.8458 8.30479 54.8398 8.29874 54.8398 8.29874C50.4158 3.85581 43.783 1.70093 34.5517 1.70093C29.2454 1.70093 24.7972 2.33045 21.3164 3.57737C18.5172 4.58218 16.1197 6.11359 14.1785 8.13531C14.142 8.18373 14.1116 8.2261 14.0629 8.2261H14.0385C13.9959 8.20794 13.9473 8.17163 13.8925 8.12925C13.8742 8.1111 13.856 8.09899 13.8316 8.08083C13.8134 8.06872 13.7951 8.05662 13.7769 8.04451C13.7343 8.0203 13.7039 8.00214 13.6917 7.97793L13.6734 7.95372V7.91135C13.6795 7.87503 13.7099 7.85687 13.7221 7.85082C15.7241 5.73831 18.2191 4.1282 21.14 3.08102C24.6755 1.81594 29.1846 1.17432 34.5517 1.17432C43.9412 1.17432 50.7079 3.38973 55.2292 7.95372C55.2292 7.95372 55.2414 7.96582 55.2475 7.97188C55.2718 7.99609 55.3144 8.02635 55.3509 8.06872L55.4361 8.16557L55.3083 8.17768C55.3083 8.17768 55.2292 8.23821 55.1805 8.27453C55.1258 8.32295 55.0649 8.37138 55.0162 8.39559L54.9736 8.4198L54.9797 8.42585ZM34.5517 1.56776C43.8134 1.56776 50.4828 3.7408 54.931 8.20189L54.9432 8.214C54.9432 8.214 54.9736 8.23821 54.9919 8.25637C55.0223 8.23216 55.0649 8.20189 55.1014 8.17163C55.144 8.14136 55.1744 8.1111 55.1988 8.09294C55.1866 8.08083 55.1744 8.06872 55.1684 8.06267C55.1562 8.05056 55.144 8.04451 55.144 8.03846C50.6471 3.50474 43.9107 1.30143 34.5578 1.30143C29.2089 1.30143 24.712 1.94305 21.1947 3.20208C18.3043 4.23715 15.8337 5.82305 13.8438 7.9174C13.8438 7.9174 13.8499 7.9174 13.856 7.92345C13.8803 7.93556 13.8986 7.94766 13.9229 7.96582C13.9473 7.98398 13.9655 7.99609 13.9899 8.01425C14.0142 8.03241 14.0446 8.05662 14.069 8.07478C14.069 8.07478 14.0751 8.06267 14.0811 8.06267C14.0872 8.05056 14.0994 8.04451 14.0994 8.03846C16.0467 6.00464 18.4686 4.46111 21.286 3.45026C24.7789 2.19728 29.2454 1.56776 34.5639 1.56776H34.5517Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.284 13.1532C57.9675 13.3651 56.4402 14.3396 53.4949 15.6834C51.4625 16.6095 50.1298 17.0756 48.5903 17.6083C47.7444 17.8988 46.8742 18.2015 45.785 18.6191C44.0507 19.2789 42.2252 20.0174 40.6795 21.2098C39.3043 22.2691 37.9777 23.6431 36.8519 25.1806C35.5375 26.9723 34.8134 28.4311 34.5091 29.1151C34.1805 28.4311 33.426 26.9663 32.2333 25.2835C31.1684 23.7824 30.0791 22.7957 29.1176 21.9301L29.0507 21.8757C28.1258 21.0403 27.0243 20.1929 23.7566 18.9642C23.2454 18.7705 22.5335 18.5162 21.7789 18.2438C20.0933 17.6385 18 16.8819 16.9594 16.4219C16.3448 16.1495 15.858 15.9437 15.4625 15.7742C13.856 15.0842 13.5456 14.951 10.7343 13.1835C10.4422 13.0019 10.3022 13.1109 10.1988 13.359C9 16.1555 8.36714 19.3697 8.36714 22.9168C8.36714 29.9323 10.3935 35.3437 14.3915 38.9997C17.3671 41.7236 21.3408 43.4245 26.2028 44.0661C29.3245 44.4777 31.9838 44.6714 34.57 44.6714C36.9189 44.6714 39.2008 44.514 41.7444 44.1751C50.3489 43.025 60.5964 38.4005 60.5964 22.8986C60.5964 19.2365 60.0122 16.0708 58.8195 13.3469C58.6917 13.0564 58.4726 13.0382 58.284 13.1653V13.1532ZM41.6897 43.7816C39.1643 44.1206 36.9006 44.278 34.5639 44.278C31.9959 44.278 29.355 44.0843 26.2515 43.6787C18.2677 42.6315 8.75659 38.1765 8.75659 22.9168C8.75659 19.4363 9.37728 16.2766 10.5517 13.5346C13.3631 15.296 13.6795 15.4352 15.3043 16.1313C15.6937 16.3008 16.1805 16.5066 16.7951 16.779C17.8479 17.2451 19.9533 18.0017 21.6389 18.6131C22.3935 18.8855 23.0994 19.1397 23.6166 19.3334C26.8235 20.5379 27.8884 21.3612 28.783 22.1662L28.8499 22.2207C29.7931 23.0742 30.8702 24.0427 31.9047 25.5075C33.5233 27.7955 34.3205 29.6599 34.3266 29.678C34.357 29.7507 34.43 29.7991 34.5091 29.7991C34.5943 29.7991 34.6613 29.7446 34.6917 29.672C34.6917 29.6538 35.3915 27.8137 37.1623 25.4106C38.2698 23.9034 39.5659 22.5597 40.9108 21.5185C42.4077 20.3624 44.2028 19.63 45.9128 18.9823C46.9959 18.5707 47.8661 18.2681 48.712 17.9775C50.2637 17.4388 51.6024 16.9788 53.6531 16.0405C56.5497 14.7149 58.0527 13.7706 58.4544 13.5043C59.6227 16.1798 60.1947 19.285 60.1947 22.8865C60.1947 38.1099 50.1298 42.6497 41.6836 43.7755L41.6897 43.7816Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.57 44.3387C32.002 44.3387 29.355 44.1511 26.2454 43.7395C18.2373 42.6862 8.69574 38.2191 8.69574 22.911C8.69574 19.4547 9.30426 16.289 10.497 13.5046L10.5274 13.4319L10.5943 13.4743C13.3996 15.2357 13.6978 15.3628 15.3408 16.065C15.7302 16.2345 16.211 16.4403 16.8316 16.7127C17.8844 17.1788 19.9838 17.9354 21.6755 18.5407C22.4239 18.8131 23.1359 19.0673 23.6471 19.261C26.8661 20.4656 27.9371 21.2948 28.8377 22.1059L28.9047 22.1665C29.854 23.0199 30.931 23.9945 31.9716 25.4654C33.6085 27.7776 34.3935 29.6299 34.3996 29.648C34.4178 29.6964 34.4665 29.7267 34.5213 29.7267C34.5761 29.7267 34.6247 29.6904 34.643 29.642C34.643 29.6238 35.3367 27.7897 37.1197 25.3685C38.2272 23.8553 39.5294 22.5054 40.8864 21.4643C42.3955 20.3021 44.1907 19.5697 45.9067 18.922C46.9959 18.5104 47.8661 18.2078 48.7059 17.9172C50.2515 17.3846 51.5903 16.9185 53.641 15.9803C56.5375 14.6607 58.0406 13.7104 58.4361 13.4501L58.503 13.4077L58.5335 13.4804C59.7079 16.174 60.2799 19.2489 60.2799 22.8868C60.2799 38.1525 50.1785 42.7105 41.7079 43.8424C39.1765 44.1813 36.9128 44.3387 34.5761 44.3387H34.57ZM10.5882 13.6256C9.41988 16.3798 8.82962 19.5031 8.82962 22.911C8.82962 38.1223 18.3103 42.5652 26.2637 43.6063C29.3671 44.0179 32.0081 44.2056 34.57 44.2056C36.9006 44.2056 39.1643 44.0482 41.6836 43.7092C50.1055 42.5833 60.14 38.0557 60.14 22.8868C60.14 19.2973 59.5801 16.2587 58.4361 13.6014C57.9554 13.9101 56.4462 14.8362 53.6897 16.0953C51.6329 17.0335 50.2941 17.4996 48.7424 18.0322C47.9026 18.3228 47.0325 18.6254 45.9493 19.037C44.2454 19.6847 42.4564 20.4111 40.9655 21.5612C39.6207 22.5962 38.3306 23.94 37.2292 25.4411C35.4645 27.8442 34.7769 29.6662 34.7708 29.6843C34.7282 29.7872 34.6369 29.8538 34.5274 29.8538C34.4179 29.8538 34.3205 29.7872 34.2779 29.6904C34.2718 29.6722 33.4868 27.826 31.8621 25.5319C30.8276 24.0671 29.7566 23.1047 28.8134 22.2573L28.7465 22.1967C27.858 21.3977 26.7931 20.5745 23.5984 19.376C23.0872 19.1823 22.3753 18.9281 21.6268 18.6557C19.9351 18.0443 17.8357 17.2877 16.7769 16.8216C16.1562 16.5492 15.6755 16.3434 15.286 16.174C13.6856 15.49 13.3448 15.3386 10.5882 13.6135V13.6256Z",
    fill: "url(#paint20_linear_402_5155)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3671 18.3831H56.355C56.3367 18.377 56.3306 18.3589 56.3428 18.3407C56.3489 18.3286 57.0852 16.9848 57.4016 16.2464C57.7181 15.5079 58.3996 13.6193 58.4118 13.5951C58.4118 13.577 58.4361 13.5709 58.4544 13.577C58.4726 13.577 58.4787 13.6012 58.4787 13.6193C58.4726 13.6375 57.785 15.5321 57.4686 16.2706C57.1521 17.009 56.4158 18.3589 56.4097 18.371C56.4037 18.3831 56.3915 18.3891 56.3793 18.3891L56.3671 18.3831Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3996 8.32294C10.4483 8.09292 10.5152 8.12924 10.4726 8.31689C10.3387 8.92219 10.3022 10.0844 10.3266 11.2708C10.3448 12.1182 10.5152 13.0261 10.5152 13.0261C10.4057 13.0201 10.2475 13.0504 10.2049 13.1956C10.071 11.8276 9.96755 10.2296 10.3996 8.32899V8.32294Z",
    fill: "url(#paint21_linear_402_5155)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.643 8.52876C58.5943 8.29875 58.5456 8.31085 58.5882 8.4985C58.7221 9.1038 58.789 10.2357 58.783 11.4221C58.7769 12.2695 58.6491 13.1109 58.6491 13.1109C58.6491 13.1109 58.8195 13.232 58.8742 13.4317C59.0811 11.3434 58.9168 9.75148 58.643 8.53482V8.52876Z",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.5071 10.2478L54.1947 12.0395L53.3489 10.7078C53.9087 9.9391 54.7911 8.58322 54.9006 8.43794C55.0102 8.29267 55.2779 8.09292 55.497 8.02029C55.716 7.94765 56.6957 7.49367 57.4868 7.20312L58.4909 8.3411L56.5071 10.2539V10.2478Z",
    fill: "url(#paint22_linear_402_5155)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5294 10.0662L14.8418 11.8579L15.6876 10.5262C15.1278 9.75746 14.2454 8.40158 14.1359 8.2563C14.0264 8.11103 13.7586 7.91128 13.5396 7.83864C13.3205 7.76601 12.3408 7.31203 11.5558 7.02148L10.5517 8.15945L12.5355 10.0722L12.5294 10.0662Z",
    fill: "url(#paint23_linear_402_5155)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7424 10.5565C15.7424 10.5565 15.4138 11.0407 15.2617 11.2768C15.1035 11.5068 14.8114 11.985 14.8114 11.985C14.8114 11.985 13.4422 11.0528 12.3286 10.0783C11.3002 9.17638 10.856 8.63161 10.4726 8.16552C10.6734 7.93551 11.4888 7.08203 11.4888 7.08203C11.4888 7.08203 11.4341 7.15467 11.6105 7.36047C12.1643 8.00815 14.3854 9.87853 15.3164 10.4778C15.5659 10.6352 15.7485 10.5565 15.7485 10.5565H15.7424Z",
    fill: "url(#paint24_linear_402_5155)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4746 7.1848C57.0852 7.32402 55.7891 7.80221 55.4848 7.91722C55.3448 7.9717 55.1501 7.95959 55.0284 7.84458C50.5193 3.40166 43.8134 1.24072 34.5517 1.24072C29.1968 1.24072 24.6876 1.88234 21.1643 3.14743C18.3529 4.15829 15.9554 5.6776 14.0203 7.63878C13.9412 7.71747 13.8073 7.778 13.6917 7.74168C13.5152 7.68115 12 7.1848 11.574 6.99716L11.5375 7.03953C11.8905 7.19086 13.3509 7.85669 13.5456 7.92327C13.7586 7.98986 14.0142 8.18961 14.1116 8.31672C14.1846 8.41357 15.7485 10.5442 15.7485 10.5442L15.7728 10.52C15.7728 10.52 14.6531 8.86755 14.3124 8.3712C14.1968 8.20777 14.1907 8.03223 14.3124 7.91117C16.2049 5.99236 18.5477 4.50331 21.3043 3.51666C24.785 2.26974 29.2454 1.63417 34.5578 1.63417C43.6917 1.63417 50.3063 3.75273 54.7363 8.09881C54.8763 8.23198 54.8702 8.36515 54.7911 8.49226C54.6268 8.75254 53.6957 10.2416 53.355 10.7198L53.3732 10.75C53.7444 10.2355 54.931 8.51647 54.9615 8.4741C55.0588 8.34093 55.3205 8.1654 55.5274 8.08065C55.6248 8.03828 57.1095 7.39666 57.5051 7.20902L57.4807 7.1848H57.4746Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3428 10.7439L54.2495 12.124C54.2495 12.124 55.5943 11.2342 56.714 10.2536C57.7424 9.35174 57.7059 9.30332 58.57 8.34089L57.5294 7.14844C57.5294 7.14844 57.5781 7.34213 57.3469 7.60242C56.7931 8.23193 54.6876 10.0478 53.7505 10.6471C53.501 10.8045 53.3428 10.7379 53.3428 10.7379V10.7439Z",
    fill: "url(#paint25_linear_402_5155)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6572 18.4438C12.6572 18.4438 12.6329 18.4438 12.6268 18.4257C12.6207 18.4136 11.8844 17.0637 11.5619 16.3253C11.2454 15.5868 10.5578 13.6922 10.5517 13.674C10.5517 13.6559 10.5517 13.6377 10.57 13.6317C10.5882 13.6256 10.6065 13.6317 10.6126 13.6498C10.6187 13.668 11.3002 15.5565 11.6227 16.295C11.9391 17.0335 12.6755 18.3772 12.6815 18.3893C12.6937 18.4075 12.6815 18.4257 12.6694 18.4317C12.6694 18.4317 12.6572 18.4317 12.6511 18.4317L12.6572 18.4438Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_402_5155",
    x1: 34.497,
    y1: 53.1096,
    x2: 34.497,
    y2: 62.4857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#595959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_402_5155",
    x1: 34.497,
    y1: 53.1094,
    x2: 34.497,
    y2: 62.4855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#C7C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5D5D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_402_5155",
    x1: 28.783,
    y1: 1.18029,
    x2: 40.3154,
    y2: 44.4477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_402_5155",
    x1: 28.783,
    y1: 1.18029,
    x2: 40.3154,
    y2: 44.4477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5A5A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_402_5155",
    x1: 28.4787,
    y1: -0.0361755,
    x2: 17.2777,
    y2: 42.0016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDCDC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_402_5155",
    x1: 42.858,
    y1: 46.2212,
    x2: 26.0446,
    y2: -0.202342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D6D6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_402_5155",
    x1: 13.9168,
    y1: 20.9495,
    x2: 20.1777,
    y2: -0.986087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "white",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#BCBCBC",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A9A9A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_402_5155",
    x1: 17.1298,
    y1: 5.71426,
    x2: 51.9067,
    y2: 5.71426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#0F0F0F",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#3F3F3F",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#616161",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#757575",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7C7C7C",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_402_5155",
    x1: 51.1156,
    y1: 40.4343,
    x2: 18.3712,
    y2: 40.4343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#565656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_402_5155",
    x1: 56.6897,
    y1: 33.6668,
    x2: 58.3294,
    y2: 38.2061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_402_5155",
    x1: 22.643,
    y1: -1.48321,
    x2: 8.65156,
    y2: 23.8995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "white",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A9A9A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_402_5155",
    x1: 49.4118,
    y1: 6.13765,
    x2: 57.7424,
    y2: 6.13765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_402_5155",
    x1: 14.7079,
    y1: 3.94032,
    x2: 14.7079,
    y2: 9.30331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_402_5155",
    x1: 17.2819,
    y1: 35.6646,
    x2: 14.955,
    y2: 42.0948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#050505",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#151515",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#262626",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#1B1B1B",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#0B0B0B",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#020202",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_402_5155",
    x1: 54.4686,
    y1: 19.3514,
    x2: 48.6897,
    y2: -0.894115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#C8C8C8",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#565656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#565656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#595959",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#636363",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#737373",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#8A8A8A",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A9A9A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_402_5155",
    x1: 11.9757,
    y1: 24.569,
    x2: 57.4746,
    y2: 24.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#727272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#919191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#080808",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#323232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#393939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#3B3B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_402_5155",
    x1: 12.4746,
    y1: 23.5341,
    x2: 32.4142,
    y2: 19.6388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_402_5155",
    x1: 34.5091,
    y1: 19.031,
    x2: 58.9047,
    y2: 19.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#363636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#5D5D5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#9C9C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_402_5155",
    x1: 44.7323,
    y1: 17.6447,
    x2: 48.2819,
    y2: 29.3013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#090909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_402_5155",
    x1: 34.5274,
    y1: 18.9459,
    x2: 10.1927,
    y2: 18.9459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#656565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#727272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#777777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#9D9D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2B2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_402_5155",
    x1: 8.69574,
    y1: 28.8732,
    x2: 60.2738,
    y2: 28.8732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#7E7E7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FCFCFC",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F5F5F5",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E9E9E9",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#D7D7D7",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#C0C0C0",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#A3A3A3",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#818181",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#595959",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#2E2E2E",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_402_5155",
    x1: 10.3083,
    y1: 13.1956,
    x2: 10.3083,
    y2: 8.16556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F8F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_402_5155",
    x1: 53.3489,
    y1: 9.61829,
    x2: 58.4909,
    y2: 9.61829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#050505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#151515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_402_5155",
    x1: 15.6815,
    y1: 9.43665,
    x2: 10.5396,
    y2: 9.43665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#050505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#151515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_402_5155",
    x1: 10.4665,
    y1: 9.52746,
    x2: 15.7363,
    y2: 9.52746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0B0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#373737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_402_5155",
    x1: 58.57,
    y1: 9.63624,
    x2: 53.3428,
    y2: 9.63624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#525252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#323232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_402_5155"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69,
    height: 63,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMazdaLogo);
export default __webpack_public_path__ + "static/media/mazda_logo.1f3951266d79a9ae969b2289f9d07f49.svg";
export { ForwardRef as ReactComponent };